import React from "react";

import { RichContentDisplay } from "@examspark/common-ui";
import { Resource } from "@examspark/types";

const ResourceViewerPassage = (props: { data: Resource }) => {
  return (
    <div className="resource-view-passage">
      {props.data.content && props.data.content.body && (
        <RichContentDisplay
          className="resource-view passage"
          content={props.data.content.body}
        />
      )}
    </div>
  );
};

export default ResourceViewerPassage;
